// TODO: get rid of inline html -> use markdown + parser instead?
export const JOB_AD_FAQ_ITEMS = [
    {
        answer:
            'Die höchste Reichweite und Sichtbarkeit erreichen Sie mit unserem Stelleninserat Premium. Zusätzlich zur' +
            ' maximalen Sichtbarkeit auf karriere.at platzieren wir Ihr Stelleninserat für mehr Reichweite auf externen' +
            ' und relevanten Partnerseiten, Gemeinde-Websites, Metajobbörsen und Premium-Publishern. Zudem bewerben wir' +
            ' es online im Google Werbenetzwerk und auf Social Media.',
        question:
            'Mit welchem Stelleninserat erreiche ich die höchste Reichweite und Sichtbarkeit?',
    },
    {
        answer:
            'Sowohl im Online Shop als auch über den Stelleninserat-Service können die Stelleninserate Basic, ' +
            'Plus (Starter – nur für Neukunden) und Premium frei kombiniert werden.<br />' +
            ' Der Unterschied zwischen diesen Buchungsmethoden liegt in der Mengenrabattberechnung:<br />' +
            ' Stelleninserat-Service: Sie profitieren von einem' +
            ' Mengenrabatt auf die Gesamtanzahl gebuchter Stelleninserate, selbst wenn Sie verschiedene Varianten kombinieren.<br />' +
            ' Beispiel: Bei 5 Premium und 5 Plus Stelleninseraten erhalten Sie den Mengenrabatt für ' +
            '10 Stelleninserate.<br /> Online Shop: Der Mengenrabatt wird separat pro Stelleninserat-Typ berechnet.<br /> ' +
            'Beispiel: Bei 5 Premium und 5 Plus Stelleninseraten erhalten Sie jeweils den 5er-Mengenrabatt auf ' +
            'beide Stelleninserat-Typen.',
        question: 'Kann ich verschiedene Stelleninserate kombinieren?',
    },
    {
        answer: 'Im Online Shop können Sie maximal 30er Kontingente der jeweiligen Stelleninserate-Typen kaufen.',
        question: 'Welche Menge kann ich im Online Shop buchen?',
    },
    {
        answer:
            'Nein. Bitte kontaktieren Sie unser Team telefonisch unter ' +
            '<a href="tel:+43732908200" class="font-semibold text-green-800 underline">+43 732 908200</a> oder per E-Mail ' +
            'an <a href="mailto:sales@karriere.at" class="font-semibold text-green-800 underline">sales@karriere.at</a>.',
        question:
            'Kann ich als Personaldienstleister auch über den Online Shop buchen?',
    },
    {
        answer:
            'Wenn Sie das Stelleninserat online buchen, ist es sofort nach der eigenständigen Veröffentlichung online ' +
            'sichtbar. Den Zeitpunkt der Onlinestellung Ihres Service-Stelleninserats vereinbaren Sie mit Ihrer ' +
            'persönlichen Ansprechperson.',
        question:
            'Wie lange dauert es, bis das Stelleninserat online sichtbar ist?',
    },
];

export const TALENT_CONTACT_FAQ_ITEMS = [
    {
        answer:
            'Sie können 20 Kontaktanfragen direkt in unserem Online Shop erwerben. Wenn Sie an einer anderen ' +
            'Talentdatenbank-Lösung interessiert sind, erreichen Sie unser Team telefonisch unter ' +
            '<a href="tel:+43732908200" class="font-semibold text-green-800 underline">+43 732 908200</a> ' +
            'oder per E-Mail an ' +
            '<a href="mailto:sales@karriere.at" class="font-semibold text-green-800 underline">sales@karriere.at</a>. ' +
            'Alternativ können Sie sich auch direkt an Ihre persönliche Ansprechperson bei karriere.at wenden.',
        question: 'Wie kann ich Kontaktanfragen buchen?',
    },
    {
        answer:
            'Unsere Lösungen passen sich flexibel Ihrem Bedarf und Ihren Ressourcen an. Bei hohem Personalbedarf ' +
            'empfehlen wir unlimitierte Kontaktanfragen mit variablen Talentdatenbank-Zugängen, passend für ' +
            'unterschiedlich große HR-Teams. Dafür stehen Ihnen die Optionen Single (1 Talentdatenbank-Nutzer), ' +
            'Multi (5 Talentdatenbank-Nutzer) und Power (10 Talentdatenbank-Nutzer) zur Verfügung. Wenn Ihr ' +
            'Personalbedarf geringer ist, können Sie je nach Bedarf zwischen 20 oder 100 Kontaktanfragen wählen.',
        question:
            'Welche Lösungen gibt es, und welche ist die richtige für mich?',
    },
    {
        answer:
            'Die Talentdatenbank ist bei Buchung von 20 Kontaktanfragen im Online-Shop sofort aktiv und direkt ' +
            'im Business Portal für Sie zur Nutzung freigeschaltet. Bei direkter Anfrage zur Buchung einer unserer ' +
            'anderen Lösungen (telefonisch unter ' +
            '<a href="tel:+43732908200" class="font-semibold text-green-800 underline">+43 732 908200</a>, per E-Mail an' +
            ' <a href="mailto:sales@karriere.at" class="font-semibold text-green-800 underline">sales@karriere.at</a> ' +
            'oder über Ihre persönliche Ansprechperson) vereinbaren Sie mit Ihrer Ansprechperson das individuelle ' +
            'Startdatum für die Talentdatenbank.',
        question: 'Ab wann kann ich die Talentdatenbank nutzen?',
    },
];

export const EMPLOYER_PROFILE_FAQ_ITEMS = [
    {
        answer:
            'Das Arbeitgeberprofil Basic und Arbeitgeberprofil Plus können Sie direkt nach der Buchung im Business Portal' +
            ' befüllen. Nach der Eingabe wird das Arbeitgeberprofil von unserem Qualitätsmanagement freigegeben und ' +
            'anschließend veröffentlicht. Sie werden informiert, sobald Ihr Arbeitgeberprofil online ist.',
        question:
            'Wie lange dauert es, bis mein Arbeitgeberprofil Basic oder Arbeitgeberprofil Plus online ist?',
    },
    {
        answer:
            'In der Jobsuche verlinkt Ihr Firmenname direkt auf Ihr Arbeitgeberprofil. Beim Stelleninserat selbst wird ' +
            'ein Auszug Ihrer Inhalte im Bereich „Arbeitgeber“ angezeigt. Interessierte Jobsuchende können in der ' +
            'Firmensuche nach Ihrem Unternehmen suchen oder Ihr Arbeitgeberprofil durch Filter wie Branche, Benefits und Bundesland finden.',
        question: 'Wo ist mein Arbeitgeberprofil auf karriere.at sichtbar?',
    },
    {
        answer:
            'Bewerbende möchten wissen, was sie bei ihrem zukünftigen Arbeitgeber erwartet. Diese Informationen helfen ' +
            'Kandidat*innen dabei, einzuschätzen, ob sie und das Unternehmen in Bezug auf Werte, Arbeitsweise und ' +
            'Unternehmenskultur harmonieren. Durch diese frühe kulturelle Passung (Cultural Fit) ziehen Sie die passenden Talente an.',
        question:
            'Wieso sind Werte, Unternehmenskultur und die Team-Vorstellung so interessant für Jobsuchende?',
    },
];
